import { render, staticRenderFns } from "./ProductionBatchCounters.vue?vue&type=template&id=4d5b509e&scoped=true&"
import script from "./ProductionBatchCounters.vue?vue&type=script&lang=js&"
export * from "./ProductionBatchCounters.vue?vue&type=script&lang=js&"
import style0 from "./ProductionBatchCounters.vue?vue&type=style&index=0&id=4d5b509e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b509e",
  null
  
)

export default component.exports